import axios from "axios";

// Create an instance of axios
const api = axios.create({
  baseURL: "https://dispatch.bostonairportexpresscar.com/",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to ensure domain_id is always present and non-null
api.interceptors.request.use(
  (config) => {
    if (config.data && typeof config.data === "object") {
      if (!config.data.domain_id) {
        config.data.domain_id = 99;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Create a separate instance for payment requests to handle CORS properly
export const paymentApi = axios.create({
  baseURL: "https://dispatch.bostonairportexpresscar.com/",
  timeout: 30000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "Accept": "application/json",
  },
});

// Interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API call failed:", error);
    return Promise.reject(error);
  }
);

export default api;
